import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import TimeSlots from "./TimeSlots.js";
const TimeSlotsContainer = ({ loading, slots, ...rest }) => {
  const {
    dateTime: { formatTime }
  } = useIntl();
  return /* @__PURE__ */ React.createElement(TimeSlots, { ...rest, loading, slots, timeFormatter: formatTime });
};
export {
  TimeSlotsContainer as default
};
//# sourceMappingURL=TimeSlotsContainer.js.map
